import { apiClient } from './api'
import type { ApiResponse } from '@/types/common'
import type {
  Batch,
  CreateBatchRequest,
  UpdateBatchRequest,
  BatchFilters,
} from '@/types/batch'

export const batchService = {
  getAllBatches: async (
    filters: BatchFilters = {}
  ): Promise<ApiResponse<Batch[]>> => {
    return apiClient.get('/batches', { params: filters })
  },

  getBatches: async (
    courseId: string,
    filters: BatchFilters = {}
  ): Promise<ApiResponse<Batch[]>> => {
    return apiClient.get(`/batches/course/${courseId}`, { params: filters })
  },

  getBatchById: async (id: string): Promise<ApiResponse<Batch>> => {
    return apiClient.get(`/batches/${id}`)
  },

  createBatch: async (data: CreateBatchRequest): Promise<ApiResponse<Batch>> => {
    return apiClient.post('/batches', data)
  },

  updateBatch: async (
    id: string,
    data: UpdateBatchRequest
  ): Promise<ApiResponse<Batch>> => {
    return apiClient.put(`/batches/${id}`, data)
  },

  activateBatch: async (id: string): Promise<ApiResponse<Batch>> => {
    return apiClient.put(`/batches/${id}/activate`)
  },

  closeBatch: async (id: string): Promise<ApiResponse<Batch>> => {
    return apiClient.put(`/batches/${id}/close`)
  },

  deleteBatch: async (id: string): Promise<ApiResponse<void>> => {
    return apiClient.delete(`/batches/${id}`)
  },
}
